export default "__VITE_ASSET__Bcj4dJI7__"